import { render, staticRenderFns } from "./WarrantInvoices.vue?vue&type=template&id=2b83047c&scoped=true"
import script from "./WarrantInvoices.vue?vue&type=script&lang=js"
export * from "./WarrantInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83047c",
  null
  
)

export default component.exports